export enum SkeletonTypes {
    TileDashboard = 'TileDashboard',
    TileDashboardThin = 'TileDashboardThin',
    TileDashboardElementThin = 'TileDashboardElementThin',
    Card = 'Card',
    Item = 'Item',
    Table = 'Table',
    SidebarTemplate = 'SidebarTemplate',
    TileEmptyStatesThin = 'TileEmptyStatesThin'
}